<span class="my-activities title-large-emphasized">{{ 'receipts.ui.leTueAttivita' | transloco }}</span>

<button
  matButton="filled"
  type="button"
  class="desktop-new-revenue-button"
  *uiCan="CAPS.incassoCrea"
  [routerLink]="newReceiptLink"
>
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  {{ 'receipts.ui.nuovoIncasso' | transloco }}
</button>

<a class="activity-card activity-card-link" [routerLink]="inProgressLink">
  <div class="activity-icon" aria-hidden="true">
    <i class="fa-regular fa-file-text"></i>
  </div>

  <div class="activity-info">
    <span class="title-medium-emphasized">{{ 'receipts.ui.incassiInLavorazione' | transloco }}</span>
    <span class="body-medium">{{ 'receipts.ui.incassiRaccoltiDaiClientiNonAncoraFinalizzati' | transloco }}</span>
  </div>

  <span class="activity-count label-small-emphasized">
    {{ incassiCount }}
  </span>

  <span class="activity-chevron" aria-hidden="true">
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</a>

<a class="activity-card activity-card-link" [routerLink]="worksheetsLink">
  <div class="activity-icon" aria-hidden="true">
    <i class="fa-regular fa-book-open"></i>
  </div>

  <div class="activity-info">
    <span class="title-medium-emphasized">{{ 'receipts.ui.brogliacci' | transloco }}</span>
    <span class="body-medium">{{ 'receipts.ui.brogliacciConfermatiDaInserireInDistinta' | transloco }}</span>
  </div>

  <span class="activity-count label-small-emphasized">
    {{ brogliacciCount }}
  </span>

  <span class="activity-chevron" aria-hidden="true">
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</a>

<a class="activity-card activity-card-link" [routerLink]="depositsLink">
  <div class="activity-icon" aria-hidden="true">
    <i class="fa-regular fa-database"></i>
  </div>

  <div class="activity-info">
    <span class="title-medium-emphasized">{{ 'receipts.ui.distinteDiVersamento' | transloco }}</span>
    <span class="body-medium">{{ 'receipts.ui.versamentiPresentatiInBancaDaChiudere' | transloco }}</span>
  </div>

  <span class="activity-count label-small-emphasized">
    {{ distinteCount }}
  </span>

  <span class="activity-chevron" aria-hidden="true">
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</a>

<button
  matFab
  extended
  type="button"
  class="new-revenue-button"
  *uiCan="CAPS.incassoCrea"
  [routerLink]="newReceiptLink"
>
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  <span class="new-revenue-label title-medium">{{ 'receipts.ui.nuovoIncasso' | transloco }}</span>
</button>
